/* ==========================================================================
   tenace-oferta-2.js — TENACE (29/10/2026)

   Mensaje «2 por €45,99 (€23,00/ud)» de la ficha y de la vista rápida:
   el elemento tenace-oferta-2 que pinta snippets/tenace-oferta-2.liquid, con
   el texto de cada variante en data-textos. Al elegir talla, el JS del tema
   cambia el input name="id" de la ficha y lanza un change: aquí se escucha y
   se pone el texto de esa variante (vacío = oculto). Solo cuentan las
   variantes de este producto: los complementarios tienen su propio id.

   Va en un fichero cargado en todas las páginas (layout/theme.liquid), y no
   dentro del snippet, porque la vista rápida mete su HTML con innerHTML y los
   script que van dentro no se ejecutan: el elemento se quedaba sin escuchar
   en los listados. Ver NORMAS-TENACE.md, «Ofertas por 2 unidades».
   ========================================================================== */
if (!customElements.get('tenace-oferta-2')) {
  customElements.define('tenace-oferta-2', class extends HTMLElement {
    connectedCallback() {
      if (this.zona) return;
      try { this.textos = JSON.parse(this.dataset.textos); } catch (error) { return; }
      this.zona = this.closest('[data-product-content]') || document;
      this.alCambiar = (evento) => {
        const campo = evento.target;
        if (!campo || campo.name !== 'id' || !Object.prototype.hasOwnProperty.call(this.textos, campo.value)) return;
        const texto = this.textos[campo.value];
        if (this.textContent !== texto) this.textContent = texto;
        this.hidden = texto === '';
      };
      this.zona.addEventListener('change', this.alCambiar);
    }

    disconnectedCallback() {
      if (this.zona) this.zona.removeEventListener('change', this.alCambiar);
      this.zona = null;
    }
  });
}
